import React, { useEffect } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { posts } from '../data/posts';
import SafeIcon from '../common/SafeIcon';
import { FiClock, FiUser, FiCalendar, FiArrowLeft, FiTag } from 'react-icons/fi';

const PostDetail = () => {
  const { id } = useParams();
  const post = posts.find(p => p.id === id);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!post) {
    return <Navigate to="/" />;
  }

  return (
    <main className="flex-grow bg-white pb-20">
      {/* Article Header */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-8">
        <Link to="/" className="inline-flex items-center gap-2 text-indigo-600 hover:text-indigo-800 font-medium mb-8 transition-colors">
          <SafeIcon icon={FiArrowLeft} />
          Kembali ke Beranda
        </Link>
        
        <div className="flex items-center gap-2 mb-6">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-indigo-50 text-indigo-700 font-semibold text-sm rounded-full">
            <SafeIcon icon={FiTag} className="text-xs" />
            {post.category}
          </span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-8">
          {post.title}
        </h1>

        <div className="flex flex-wrap items-center gap-6 text-sm text-gray-500 border-b border-gray-100 pb-8">
          <div className="flex items-center gap-2 text-gray-900 font-medium">
            <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 font-bold text-lg">
              {post.author.charAt(0)}
            </div>
            <span>{post.author}</span>
          </div>
          <div className="flex items-center gap-2">
            <SafeIcon icon={FiCalendar} />
            <span>{post.date}</span>
          </div>
          <div className="flex items-center gap-2">
            <SafeIcon icon={FiClock} />
            <span>{post.readTime}</span>
          </div>
        </div>
      </div>

      {/* Featured Image */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <img 
          src={post.image} 
          alt={post.title} 
          className="w-full h-[400px] md:h-[500px] lg:h-[600px] object-cover rounded-2xl shadow-lg"
        />
      </div>

      {/* Article Content */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <article 
          className="article-content"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
        
        {/* Author Bio Box */}
        <div className="mt-16 bg-gray-50 rounded-2xl p-8 border border-gray-100 flex items-start gap-6">
          <div className="w-16 h-16 rounded-full bg-indigo-600 flex-shrink-0 flex items-center justify-center text-white font-bold text-2xl">
            {post.author.charAt(0)}
          </div>
          <div>
            <h4 className="text-lg font-bold text-gray-900 mb-2">Ditulis oleh {post.author}</h4>
            <p className="text-gray-600">
              Tim redaksi InfoKonveksi yang berdedikasi untuk memberikan informasi terbaik dan terpercaya seputar industri tekstil, fashion, dan konveksi di Indonesia.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PostDetail;